import React from "react";
import SleepType from "./SleepType";
import TimePicker from "./TimePicker";
import Results from "./Results";

// Must match the server-rendered shell in views/outils/calculateur_de_sommeil.html.erb,
// otherwise the tool visibly jumps when React replaces it.
const DEFAULT_SLEEP_TYPE = "wakeUp";
const DEFAULT_TIME = { hour: '7', minute: '0' };

export default function App() {
    const [sleepType, setSleepType] = React.useState(DEFAULT_SLEEP_TYPE)
    const [time, setTime] = React.useState(DEFAULT_TIME);
    const [bestTimes, setBestTimes] = React.useState([]);

    const handleTimeChange = (hour, minute) => {
        setTime({ hour, minute });
    };

    const showResults = () => {
        return sleepType && time.hour !== '' && time.minute !== '' && bestTimes.length > 0;
    };

    React.useEffect(() => {
        if (!time.hour || !time.minute || !sleepType) return;

        const fallAsleepTime = 15;
        const sleepCycle = 90;
        const numberOfCycles = 6;

        const inputTimeInMinutes = parseInt(time.hour) * 60 + parseInt(time.minute);
        let times = [];

        if (sleepType === "wakeUp") {
            for (let i = 1; i <= numberOfCycles; i++) {
                const bedtimeInMinutes = inputTimeInMinutes - fallAsleepTime - i * sleepCycle;
                let normalizedBedtime = (bedtimeInMinutes + 1440) % 1440;
                const hour = Math.floor(normalizedBedtime / 60);
                const minute = normalizedBedtime % 60;
                times.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
            }
        } else if (sleepType === "sleep") {
            for (let i = 1; i <= numberOfCycles; i++) {
                const wakeTimeInMinutes = inputTimeInMinutes + fallAsleepTime + i * sleepCycle;
                let normalizedWakeTime = wakeTimeInMinutes % 1440;
                const hour = Math.floor(normalizedWakeTime / 60);
                const minute = normalizedWakeTime % 60;
                times.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
            }
        }

        setBestTimes(times);

    }, [sleepType, time]);

    return (
        <>
            <div className="flex w-full text-center gap-2 sm:gap-4">
                <SleepType
                    onClick={() => setSleepType("wakeUp")}
                    sleepType="wakeUp"
                    selected={sleepType == "wakeUp"}
                />
                <SleepType
                    onClick={() => setSleepType("sleep")}
                    sleepType="sleep"
                    selected={sleepType == "sleep"}
                />
            </div>

            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg">
                <TimePicker
                    hour={time.hour}
                    minute={time.minute}
                    onTimeChange={handleTimeChange}
                    showNow={sleepType == "sleep"}
                />
            </div>

            <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default ">
                Résultats
            </div>

            <div className="">
                {showResults() &&
                    <Results sleepType={sleepType} bestTimes={bestTimes} time={time} />
                }
            </div>
        </>
    );
}